var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('div',[_c('top-bar'),(_vm.$vuetify.breakpoint.mobile)?_c('side-nav'):_vm._e(),_c('v-main',[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }